export default __webpack_public_path__ + "static/games-app-dd15915d95cdb31acac82daf5658129c.png";